<div fxLayout='column' fxLayoutAlign="space-between" class="w-100 pt-5 pb-5">
    <mat-toolbar class="bg-white">
        <app-brand class="d-flex d-inline-sm" [class.mr-auto]="routeService.isUserPage"></app-brand>
        <app-searchbar *ngIf="!routeService.isUserPage" class="ff-roboto mr-auto ml-auto pstn-relative"></app-searchbar>
        <auth-menu></auth-menu>
    </mat-toolbar>
</div>